import { SupportedIconName } from '../../icons';
import { SupportedColor } from '../../../components/Element/Element';
import { ResolveIconProps } from '../../../components/Input/ResolveIcon';

type ResolveIconPropsType = (props: ResolveIconProps) => any;

export const resolveIconProps: ResolveIconPropsType = ({
  errorText,
  confirmed,
  iconName,
  disabled,
  onIconClick,
  iconColor,
  handleKeyPress,
}) => {
  if (errorText !== ' ' && errorText) {
    return {
      name: 'error-filled' as SupportedIconName,
      color: 'red600' as SupportedColor,
    };
  }

  if (confirmed) {
    return {
      name: 'checkmark' as SupportedIconName,
      color: 'green500' as SupportedColor,
    };
  }

  if (!iconName) {
    return undefined;
  }
  if (disabled) {
    return {
      name: iconName,
      color: 'gray400' as SupportedColor,
    };
  }

  if (onIconClick) {
    return {
      name: iconName,
      color: iconColor || ('black' as SupportedColor),
      onClick: onIconClick,
      clickableAppearance: true,
      onKeyPress: handleKeyPress,
      tabIndex: 0,
    };
  }

  return {
    name: iconName,
    color: iconColor || ('black' as SupportedColor),
  };
};
